import React, { useEffect, useState } from 'react'
import { Button, Tree, message, Input, Tabs } from 'antd'
import { YhBox } from '@/components/YhBox'
import { FormBox } from './FormBox'
import { EventDataNode, DataNode } from 'antd/lib/tree'
import { useDictModel } from '../assetsClassModel'
import { IDictDetail, IDictSearch } from '../assetsClassService'
import { DeleteOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'

export const DataBox = () => {
    //查询条件
    const [searchParam, setSearchParam] = useState<IDictSearch>()
    const { treeSource, tabsList, changeTabs, setChangeTabs, loadData, setMode, setSelectedNodes, selectedNodes, setFormVal, removeOneDict, sync, setTreeSource, firstLoad } = useDictModel()

    const [searchData, setSearchData] = useState([...treeSource])

    const [expandedKeys, setExpandedKeys] = useState<string[]>([])

    useEffect(() => {
        firstLoad()
        // loadData()
    }, [])

    //字典选中事件
    const onSelect = (
        selectedKeys: React.Key[],
        info: {
            event: 'select'
            selected: boolean
            node: EventDataNode
            selectedNodes: DataNode[]
            nativeEvent: MouseEvent
        }
    ) => {
        let selectNode = info.selectedNodes as IDictDetail[]
        // console.log(selectNode[0])
        console.log(info)
        setMode(info.selected ? 'edit' : '')
        setSelectedNodes(selectNode)
        setFormVal({ nameEn: '', ...selectNode[0] })
    }

    const action = (
        <>
            {treeSource.length <= 0 && (
                <Button className="mr-5" type="link" shape="round" onClick={() => setMode('root')}>
                    增加根级
                </Button>
            )}
            {/* <YhAuth resCode={ResourceAuthEnum.DATA_DIC_SUB}> */}
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedNodes.length) {
                        message.warning('请选择要增加的父级')
                        return
                    }
                    message.success('增加下级模式开启')
                    setMode('nextAdd')
                }}
            >
                增加下级
            </Button>
            {/* </YhAuth> */}
            {/* <YhAuth resCode={ResourceAuthEnum.DATA_DIC_BRO}> */}
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (!selectedNodes.length) {
                        message.warning('请选择要增加的同级')
                        return
                    }
                    message.success('增加同级模式开启')
                    setMode('add')
                }}
            >
                增加同级
            </Button>
            {/* </YhAuth> */}
            {/* <YhAuth resCode={ResourceAuthEnum.DATA_DIC_SYNC}> */}
            <Button className="mr-5" type="link" shape="round" onClick={() => sync()}>
                同步
            </Button>
            {/* </YhAuth> */}
            {/* {treeSource.length > 0 && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedNodes.length && selectedNodes[0].children.length) { 
                    message.warning("请选择要删除的节点并且子节点为空");
                    return;
                }
                removeOneDict(selectedNodes[0].code);
            }}
        >删除</Button>} */}
        </>
    )
    const handleInsert = () => {
        if (selectedNodes.length === 0) {
            // 进入添加父级模式
            message.success('进入添加父级模式')
            setMode('root')
        } else {
            // 进入添加子级模式
            message.success('进入添加子级模式')
            setMode('nextAdd')
        }
    }

    const handleSearch = (value: string) => {
        const searchText = value.toLowerCase()
        let data = JSON.parse(JSON.stringify(searchData))
        const filteredResults = data.filter((item) => {
            // 检查一级的 name 字段是否包含搜索文本
            if (item.name.toLowerCase().includes(searchText) || item.code.toLowerCase().includes(searchText)) {
                if (item.name.toLowerCase() === value || item.code.toLowerCase() === value) {
                    setMode('edit')
                    setSelectedNodes([item])
                    setFormVal({ nameEn: '', ...item })
                } else {
                    setMode('')
                    setSelectedNodes([])
                }
                return true
            }

            // 检查 children 中的 name 字段是否包含搜索文本
            if (item.children && item.children.length > 0) {
                const filteredChildren = item.children.filter((child) => {
                    let b = child.name.toLowerCase().includes(searchText) || child.code.toLowerCase().includes(searchText)
                    if (child.name.toLowerCase() === value || child.code.toLowerCase() === value) {
                        setMode('edit')
                        setSelectedNodes([child])
                        setFormVal({ nameEn: '', ...child })
                    }
                    return b
                })

                if (filteredChildren.length > 0) {
                    // 更新 item 的 children 为筛选后的结果
                    item.children = filteredChildren
                    return true
                }
            }

            return false
        })
        setTreeSource(filteredResults)
    }

    return (
        <YhBox>
            <div className="dict-container flex">
                <div className="dict-list-boxes">
                    <span className="dict-list-title">资产分类</span>
                    <Tabs
                        style={{ marginTop: '20px' }}
                        type="card"
                        defaultActiveKey={changeTabs}
                        onChange={(e) => {
                            setChangeTabs(e)
                            loadData(e)
                        }}
                    >
                        {tabsList.map((item: any) =>
                            <Tabs.TabPane tab={item.label} key={item.value} />
                        )}
                    </Tabs>
                    <div style={{ float: 'right',marginBottom:'20px' }}>
                        <div>
                            {/* <Button size={'small'} style={{ float: 'right', marginLeft: '10px' }}> 导入 </Button>
                            <Button onClick={() => {handleInsert()}} type="primary" size={'small'} style={{ float: 'right' }} > <PlusOutlined /> 新增 </Button> */}
                            {treeSource.length <= 0 && (<Button className="mr-5" type="primary" shape="round" onClick={() => setMode('root')}> 增加根级</Button>)}
                            <Button className="mr-5" type="primary" shape="round"
                                onClick={() => {
                                    if (!selectedNodes.length) {
                                        message.warning('请选择要增加的父级')
                                        return
                                    }
                                    message.success('增加下级模式开启')
                                    setMode('nextAdd')
                                }}
                            > 增加下级 </Button>
                            <Button className="mr-5" type="primary" shape="round"
                                onClick={() => {
                                    if (!selectedNodes.length) {
                                        message.warning('请选择要增加的同级')
                                        return
                                    }
                                    message.success('增加同级模式开启')
                                    setMode('add')
                                }}
                            >
                                增加同级
                            </Button>
                        </div>
                    </div>
                    <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                        <Input
                            prefix={<SearchOutlined className="site-form-item-icon" />}
                            placeholder="请输入回车检索"
                            size="small"
                            style={{ width: '100%' }}
                            value={searchParam?.value}
                            onChange={(e) => {
                                setSearchParam({ value: e.target.value })
                                handleSearch(e.target.value)
                            }}
                        />
                    </div>
                    {treeSource.length > 0 && (
                        <div className="dict-list-boxs">
                            <Tree
                                defaultExpandedKeys={[selectedNodes[0]?.key]}
                                selectedKeys={[selectedNodes[0]?.key]}
                                //titleRender={(node: any) => `${node.name}`}
                                defaultExpandAll={treeSource.length !== searchData.length}
                                titleRender={(node: any) => (
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span>{node.name}</span>
                                        {/* <span
                                        style={{ marginLeft: 'auto', fontSize: '14px' }}
                                        onClick={() => {
                                            removeOneDict(node.code)
                                        }}
                                    >
                                        <DeleteOutlined />
                                    </span> */}
                                    </div>
                                )}
                                blockNode
                                onSelect={onSelect}
                                treeData={treeSource}
                            />
                        </div>
                    )}
                </div>
                <div style={{ borderRight: '1px solid #e0e0e0', margin: '10px 0' }}></div>
                <div className="dict-from-boxes flex">
                    {selectedNodes.length > 0 ? <FormBox /> : <div className="dict-init-box flex flex-1 items-center justify-center">资产分类</div>}
                </div>
            </div>
        </YhBox>
    )
}
